var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPersonCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10 0a10 10 0 1010 10A10 10 0 0010 0zm0 3a3 3 0 11-3 3 3 3 0 013-3zm0 14.2a7.2 7.2 0 01-6-3.22c.03-1.99 4-3.08 6-3.08s5.97 1.09 6 3.08a7.2 7.2 0 01-6 3.22z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMCAyMCI+CiAgICA8cGF0aCBmaWxsPSJjdXJyZW50Q29sb3IiCiAgICAgICAgICBkPSJNMTIsMkExMCwxMCwwLDEsMCwyMiwxMiwxMCwxMCwwLDAsMCwxMiwyWm0wLDNBMywzLDAsMSwxLDksOCwzLDMsMCwwLDEsMTIsNVptMCwxNC4yYTcuMiw3LjIsMCwwLDEtNi0zLjIyYy4wMy0xLjk5LDQtMy4wOCw2LTMuMDhzNS45NywxLjA5LDYsMy4wOEE3LjIsNy4yLDAsMCwxLDEyLDE5LjJaIgogICAgICAgICAgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTIgLTIpIgogICAgLz4KPC9zdmc+";
export { SvgPersonCircle as ReactComponent };